import React from 'react';
import { motion } from 'framer-motion';
import { COLORS } from '../constants/colors.ts';

interface VideoSectionProps {
  showContent: boolean;
  videoEnded: boolean;
  videoError: boolean;
  videoRef: React.RefObject<HTMLVideoElement>;
  loopVideoRef: React.RefObject<HTMLVideoElement>;
  onVideoEnded: () => void;
  onVideoError: () => void;
  onVideoLoaded: () => void;
  videoPath: string;
}

const VideoSection: React.FC<VideoSectionProps> = ({
  showContent,
  videoEnded,
  videoError,
  videoRef,
  loopVideoRef,
  onVideoEnded,
  onVideoError,
  onVideoLoaded,
  videoPath
}) => {
  return (
    <div className="relative w-full max-w-[430px] h-screen">
      {/* Always show the main video - no transition to loop video */}
      <motion.div 
        key="intro"
        initial={{ opacity: 1 }}
        animate={{ opacity: 1 }}
        className="absolute inset-0"
      >
        {/* Error fallback */}
        {videoError && (
          <div 
            className="absolute inset-0 flex items-center justify-center z-20"
            style={{ 
              background: `linear-gradient(to bottom, ${COLORS.secondary}, ${COLORS.secondaryLight})`
            }}
          >
            <div className="text-white text-center px-8">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
              >
              </motion.div>
            </div>
          </div>
        )}
        <video 
          ref={videoRef}
          className="absolute inset-0 w-full h-full object-cover mobile-video"
          width="100%"
          height="100%"
          playsInline
          muted
          loop
          preload="metadata"
          controls={false}
          disablePictureInPicture
          disableRemotePlayback
          x-webkit-airplay="deny"
          controlsList="nodownload nofullscreen noremoteplayback"
          onContextMenu={(e) => e.preventDefault()}
          style={{ 
            display: 'block !important', 
            width: '100% !important', 
            height: '100% !important',
            objectFit: 'cover',
            objectPosition: 'center center',
            backgroundColor: '#000000',
            position: 'absolute',
            zIndex: '1',
            pointerEvents: 'none',
            userSelect: 'none',
            outline: 'none',
            border: 'none'
          }}
          onEnded={() => onVideoEnded()}
          onError={() => {
            onVideoError();
            // Fallback: show content immediately if video fails
            setTimeout(() => {
              onVideoEnded();
            }, 1000);
          }}
          onLoadedData={() => {
            onVideoLoaded();
          }}
          onCanPlay={() => {
            // Video can start playing
          }}
          onLoadStart={() => {
            // Video load started
          }}
          onLoadedMetadata={() => {
            // Video metadata loaded
          }}
          onPlay={() => {
            // Video started playing
          }}
          onTimeUpdate={() => {
            // Video time update
          }}
        >
          <source src={videoPath} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </motion.div>
    </div>
  );
};

export default VideoSection;
